var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoRecorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 6.22926V18.4315L17.5463 13.9868V17.8655C17.5463 18.1618 17.4383 18.4248 17.2228 18.6531C17.0067 18.8829 16.7498 18.9967 16.4537 18.9967H3.13414C2.80989 18.9967 2.53968 18.8829 2.32425 18.6531C2.10808 18.4248 2 18.1618 2 17.8655V6.79519C2 6.49893 2.10808 6.23665 2.32425 6.00688C2.53968 5.77858 2.80989 5.66333 3.13414 5.66333H16.4537C16.7498 5.66333 17.0067 5.77858 17.2228 6.00688C17.4383 6.23665 17.5463 6.49893 17.5463 6.79519V10.674L22 6.22926Z",
  fill: "#001246"
})));
export default SvgVideoRecorder;